var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var inflection = require('inflection');

var pathProxy = require('path-proxy');

var promisifyCall = require('promisify-call');

var Builder = /*#__PURE__*/function () {
  "use strict";

  function Builder(baseObj, resources) {
    _classCallCheck(this, Builder);

    this.baseObj = baseObj;
    this.resources = resources;
  }

  _createClass(Builder, [{
    key: "build",
    value: function build() {
      var _this = this;

      Object.keys(this.resources).forEach(function (key) {
        // console.log('building ' + key);
        _this.buildResource(_this.resources[key]);
      });
    }
  }, {
    key: "buildResource",
    value: function buildResource(resource) {
      resource.links.forEach(this.buildAction, this);
    }
  }, {
    key: "buildAction",
    value: function buildAction(action) {
      var actionName = action.title;
      var properties = action.properties;
      var requiredProps = action.required; // HACKY special case for members bulk add and send MIME endpoints

      var path = action.href.replace(/\.json/gi, '').replace(/\.mime/gi, '');
      var constructor = pathProxy.pathProxy(this.baseObj, path);

      function impl(data, fn) {
        var requestPath = action.href;
        var pathParams = action.href.match(/{[^}]+}/g) || [];

        if (typeof data === 'function') {
          fn = data;
          data = undefined;
        }

        var err;

        if (this.params.length !== pathParams.length) {
          err = new Error("Invalid number of params in path (expected ".concat(pathParams.length, ", got ").concat(this.params.length, ")."));
          return fn(err);
        }

        this.params.forEach(function (param) {
          requestPath = requestPath.replace(/{[^}]+}/, param);
        }); // check required payload properties

        if (requiredProps && requiredProps.length > 0) {
          if (!data) {
            err = new Error('Missing parameters.');
          } else {
            for (var i = 0; i < requiredProps.length; i++) {
              var prop = requiredProps[i];

              if (typeof data[prop] === 'undefined') {
                err = new Error("Missing parameter '".concat(prop, "'"));
                break;
              }
            }
          }
        }

        if (err) {
          return fn(err);
        } // check payload property types


        for (var key in properties) {
          if (data && data[key]) {
            var type = properties[key].type;
            var dataType = typeof data[key];

            if (Array.isArray(data[key])) {
              dataType = 'array';
            }

            if (Array.isArray(type)) {
              if (type.indexOf(dataType) === -1) {
                err = new Error("Invalid parameter type. ".concat(key, " must be of type: ").concat(type, "."));
                break;
              }
            } else if (dataType !== type) {
              err = new Error("Invalid parameter type. ".concat(key, " must be of type: ").concat(type, "."));
              break;
            }
          }
        }

        if (err) {
          return fn(err);
        }

        this.client = this.base;
        return this.client.request(action.method, requestPath, data, fn);
      }

      function promisifed(data, fn) {
        return promisifyCall(this, impl, data, fn);
      }

      constructor.prototype[getName(actionName)] = promisifed;
    }
  }]);

  return Builder;
}();

function getName(name) {
  name = name.toLowerCase();
  name = inflection.dasherize(name).replace(/-/g, '_');
  name = inflection.camelize(name, true);
  return name;
}

function build(baseObj, resources) {
  var b = new Builder(baseObj, resources);
  b.build();
}

exports.build = build;